document.addEventListener('alpine:init', () => {
  Alpine.store('productForm', {
    currentVariant: null,
    selectedColor: null
  });

  Alpine.data('dropdown', (optionName, defaultValue) => ({
    isOpen: false,
    selectedValue: defaultValue || '',
    optionName: optionName,
    focusedOptionIndex: -1,
    liveMessage: '',

    init() {
      this.selectedValue = defaultValue || '';
      console.log('Dropdown initialized:', this.optionName);
    },

    toggle() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.focusedOptionIndex = -1;
        this.announceDropdownState();
      }
      console.log('Dropdown toggled:', this.isOpen);
    },

    close() {
      this.isOpen = false;
      this.focusedOptionIndex = -1;
    },

    getDropdownLabel() {
      const allSoldOut = this.checkAllOptionsSoldOut();
      let label = `${this.optionName} dropdown`;
      
      if (allSoldOut) {
        label += ` - all ${this.optionName.toLowerCase()}s sold out`;
      } else if (this.selectedValue) {
        label += ` - ${this.optionName.toLowerCase()} ${this.selectedValue} selected`;
      }
      
      // label += ` - ${this.isOpen ? 'expanded' : 'collapsed'}`;
      return label;
    },

    getOptionClasses(optionValue, index) {
      let classes = {};
      classes['c-dropdown__option--selected'] = this.selectedValue === optionValue;
      classes['c-dropdown__option--focused'] = this.focusedOptionIndex === index;
      return classes;
    },

    getOptionLabel(optionValue) {
      const isAvailable = this.isOptionAvailable(this.optionName, optionValue);
      let label = `${this.optionName} ${optionValue}`;
      if (!isAvailable) {
        label += ' - sold out';
      }
      return label;
    },

    checkAllOptionsSoldOut() {
      // Get option values from the hidden select instead of DOM querying
      const hiddenSelect = this.$refs.hiddenSelect;
      if (!hiddenSelect) return false;
      
      const options = Array.from(hiddenSelect.querySelectorAll('option'));
      const valueOptions = options.filter(option => option.value !== '');
      
      return valueOptions.length > 0 && valueOptions.every(option => {
        return !this.isOptionAvailable(this.optionName, option.value);
      });
    },

    announceDropdownState() {
      const allSoldOut = this.checkAllOptionsSoldOut();
      if (allSoldOut) {
        this.liveMessage = `All ${this.optionName.toLowerCase()}s are sold out`;
      } else if (this.isOpen) {
        this.liveMessage = `${this.optionName} dropdown expanded`;
      }
      
      // Clear message after announcement
      setTimeout(() => {
        this.liveMessage = '';
      }, 1000);
    },

    selectOption(value) {
      console.log('Option selected:', value);
      this.selectedValue = value;
      this.isOpen = false;
      this.focusedOptionIndex = -1;
      
      // Update the hidden select element
      this.$refs.hiddenSelect.value = value;
      
      // Announce the selection
      this.liveMessage = `${this.optionName} ${value} selected`;
      setTimeout(() => {
        this.liveMessage = '';
      }, 1000);
      
      // Trigger change event to update the product form
      this.$refs.hiddenSelect.dispatchEvent(new Event('change'));
    },

    isOptionAvailable(optionName, optionValue) {
      // Access the parent productForm component to check availability
      const productForm = this.$el.closest('[x-data*="productForm"]');
      if (productForm && productForm._x_dataStack) {
        const productFormData = productForm._x_dataStack.find(data => data.isOptionAvailable);
        return productFormData ? productFormData.isOptionAvailable(optionName, optionValue) : true;
      }
      return true;
    },

    updateVariant() {
      // Find parent productForm and trigger variant update
      const productForm = this.$el.closest('[x-data*="productForm"]');
      if (productForm && productForm._x_dataStack) {
        const productFormData = productForm._x_dataStack.find(data => data.updateVariant);
        if (productFormData) {
          productFormData.updateVariant();
        }
      }
    },

    handleKeyDown(event) {
      console.log('Key pressed:', event.key, 'Dropdown open:', this.isOpen);
      
      // Handle dropdown toggle keys when closed
      if (!this.isOpen) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggle();
          return;
        }
        return;
      }

      // Handle navigation when dropdown is open
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          this.focusNextOption();
          break;
        case 'ArrowUp':
          event.preventDefault();
          this.focusPreviousOption();
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.selectFocusedOption();
          break;
        case 'Home':
          event.preventDefault();
          this.focusedOptionIndex = 0;
          this.announceFocusedOption();
          break;
        case 'End':
          event.preventDefault();
          this.focusedOptionIndex = this.getOptionCount() - 1;
          this.announceFocusedOption();
          break;
        case 'Escape':
          event.preventDefault();
          this.close();
          break;
      }
    },

    getOptionCount() {
      const hiddenSelect = this.$refs.hiddenSelect;
      if (!hiddenSelect) return 0;
      
      const options = hiddenSelect.querySelectorAll('option[value]:not([value=""])');
      return options.length;
    },

    getOptionValueByIndex(index) {
      const hiddenSelect = this.$refs.hiddenSelect;
      if (!hiddenSelect) return null;
      
      const options = Array.from(hiddenSelect.querySelectorAll('option[value]:not([value=""])'));
      return options[index]?.value || null;
    },

    focusNextOption() {
      const maxIndex = this.getOptionCount() - 1;
      if (this.focusedOptionIndex < maxIndex) {
        this.focusedOptionIndex++;
      } else {
        this.focusedOptionIndex = 0; // Wrap to first option
      }
      this.announceFocusedOption();
    },

    focusPreviousOption() {
      const maxIndex = this.getOptionCount() - 1;
      if (this.focusedOptionIndex > 0) {
        this.focusedOptionIndex--;
      } else {
        this.focusedOptionIndex = maxIndex; // Wrap to last option
      }
      this.announceFocusedOption();
    },

    selectFocusedOption() {
      const optionValue = this.getOptionValueByIndex(this.focusedOptionIndex);
      if (optionValue && this.isOptionAvailable(this.optionName, optionValue)) {
        this.selectOption(optionValue);
      } else {
        console.log('Option not available or not found:', optionValue);
      }
    },

    announceFocusedOption() {
      const optionValue = this.getOptionValueByIndex(this.focusedOptionIndex);
      if (optionValue) {
        const isAvailable = this.isOptionAvailable(this.optionName, optionValue);
        this.liveMessage = isAvailable 
          ? `${this.optionName} ${optionValue}` 
          : `${this.optionName} ${optionValue} - sold out`;
        
        setTimeout(() => {
          this.liveMessage = '';
        }, 1000);
      }
    }
  }));

  Alpine.data('productForm', (variants, variantMetafields, hasVariantPresale = false) => ({
    variants: variants,
    variantMetafields: variantMetafields,
    hasVariantPresale: hasVariantPresale,
    showPreorderBadge: false,
    currentVariant: null,
    selectedOptions: {},

    init() {
      const params = new URLSearchParams(window.location.search);
      const color = params.get('color');

      if (color) {
        // URL decode and normalize the color parameter
        const decodedColor = decodeURIComponent(color);
        
        // Find matching color option (case-insensitive)
        const matchingColor = this.findMatchingColorOption(decodedColor);
        
        if (matchingColor) {
          this.selectedOptions.color = matchingColor;
          // Pre-select the color swatch
          this.preselectColorSwatch(matchingColor);
        }
      }

      if (this.variants.length === 1) {
        this.currentVariant = this.variants[0];
        this.$store.productForm.currentVariant = this.currentVariant;
      } else {
        this.gatherSelectedOptions();
        this.updateVariant();
      }
    },

    shouldShowPresale() {
      // Reset badge
      this.showPreorderBadge = false;
      
      if (this.currentVariant) {
        // Check if current variant ID is in the preorder variants array
        if (this.variantMetafields.includes(this.currentVariant.id)) {
          this.showPreorderBadge = true;
        }
      }
    },

    gatherSelectedOptions() {
      const form = this.$el.closest('form');
      const formData = new FormData(form);

      // Clear existing selections first
      this.selectedOptions = {};

      for (let [key, value] of formData.entries()) {
        if (key.startsWith('options[')) {
          const optionName = key.replace('options[', '').replace(']', '');
          // Set the option if it has a value (radio buttons will always have values when checked)
          // Only exclude empty strings from select dropdowns
          if (value && value.trim() !== '') {
            this.selectedOptions[optionName] = value;
          }
        }
      }
    },

    updateVariant() {
      this.gatherSelectedOptions();
      
      // Track color selection independently
      this.updateSelectedColor();
      
      // Get all required option names
      const form = this.$el.closest('form');
      const allOptionSelects = form.querySelectorAll('select[name^="options["], input[name^="options["]:checked');
      const requiredOptionNames = Array.from(allOptionSelects).map(el => {
        const name = el.getAttribute('name');
        return name.replace('options[', '').replace(']', '');
      });
      
      // Check if all required options are selected
      const allOptionsSelected = requiredOptionNames.every(optionName => 
        this.selectedOptions[optionName] && this.selectedOptions[optionName].trim() !== ''
      );
      
      if (!allOptionsSelected) {
        this.currentVariant = null;
      } else {
        this.currentVariant = this.variants.find(variant => {
          // Match variant options against selected options in the correct order
          return variant.options.every((variantOption, index) => {
            const optionName = requiredOptionNames[index];
            return this.selectedOptions[optionName] === variantOption;
          });
        });
      }
      
      // Update the global store for other components to listen
      this.$store.productForm.currentVariant = this.currentVariant;
      this.shouldShowPresale();
    },

    updateSelectedColor() {
      // Find color option by checking option names (matching product-form.liquid logic)
      let selectedColor = null;
      
      for (const [optionName, optionValue] of Object.entries(this.selectedOptions)) {
        const optionNameLower = optionName.toLowerCase();
        if (optionNameLower === 'color' || 
            optionNameLower === 'colour' || 
            optionNameLower === 'colors' || 
            optionNameLower === 'colours') {
          selectedColor = optionValue;
          break;
        }
      }
      
      // Update store with selected color (could be null if no color selected)
      this.$store.productForm.selectedColor = selectedColor;
    },

    isOptionAvailable(optionName, optionValue) {
      const testOptions = { ...this.selectedOptions, [optionName]: optionValue };
      
      return this.variants.some(variant => {
        // Get the product's option names in the correct order
        const form = this.$el.closest('form');
        const optionSelects = form.querySelectorAll('select[name^="options["], input[name^="options["]:checked');
        const orderedOptionNames = Array.from(optionSelects).map(el => {
          const name = el.getAttribute('name');
          return name.replace('options[', '').replace(']', '');
        });
        
        // Match variant options against test options in the correct order
        return variant.options.every((variantOption, index) => {
          const optionNameAtIndex = orderedOptionNames[index];
          const testValue = testOptions[optionNameAtIndex];
          // If test value is empty/null, skip this check (option not selected)
          return !testValue || testValue.trim() === '' || testValue === variantOption;
        }) && variant.available;
      });
    },

    findMatchingColorOption(queryColor) {
      // Get all available color options from the form
      const form = this.$el.closest('form');
      // Look for color inputs based on common color option names
      const colorInputs = form.querySelectorAll('input[type="radio"][name*="color"], input[type="radio"][name*="Color"], input[type="radio"][name*="colour"], input[type="radio"][name*="Colour"]');
      
      // Extract color values and find case-insensitive match
      for (const input of colorInputs) {
        const colorValue = input.value;
        if (colorValue.toLowerCase() === queryColor.toLowerCase()) {
          return colorValue;
        }
      }
      
      return null;
    },

    preselectColorSwatch(colorValue) {
      // Wait for DOM to be ready, then select the matching radio button
      this.$nextTick(() => {
        const form = this.$el.closest('form');
        // Look for color inputs based on common color option names
        const colorInputs = form.querySelectorAll('input[type="radio"][name*="color"], input[type="radio"][name*="Color"], input[type="radio"][name*="colour"], input[type="radio"][name*="Colour"]');
        
        for (const input of colorInputs) {
          if (input.value === colorValue) {
            input.checked = true;
            // Trigger change event to update the form
            input.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      });
    },

    formatMoney(cents) {
      return (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    },

    async handleCartDrawer(event) {
      event.preventDefault();
      const form = event.target.closest('form');
      const formData = new FormData(form);
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          // /cart/add.js returns the added line item, not the cart totals.
          // Fetch /cart.js to get the authoritative item_count for the badge.
          const cart = await fetch('/cart.js').then((r) => r.json());
          Alpine.store('cart').updateCount(cart.item_count);
          Alpine.store('cartDrawer').open();
        } else {
          // Fallback: submit normally
          form.submit();
        }
      } catch (error) {
        // Fallback: submit normally  
        form.submit();
      }
    }
  }));
});